export enum EAppGoalMode {
    NoStop = 0,
    Stop = 1,
    Minimal = 2,

}